import confetti from 'canvas-confetti';

export const triggerConfetti = () => {
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
    zIndex: 1500
  };

  function fire(particleRatio: number, opts: any) {
    confetti({
      ...defaults,
      particleCount: Math.floor(count * particleRatio),
      spread: 26,
      startVelocity: 55,
      ...opts,
    });
  }

  // Fire confetti from left and right
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
    origin: { x: 0 }
  });
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
    origin: { x: 1 }
  });

  // Fire confetti from center
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  });

  // Fire stars
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
    shapes: ['star']
  });
}; 